import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, CanActivateChild, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Injectable({
  providedIn: 'root'
})
export class VendorGuardGuard implements CanActivateChild {
  
  constructor(
    private router: Router,
    private cryptoJsService: CryptoJsService
  ) { }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encDataD);
    const isVendorLogin = loginDetails.get('isVendor') ? loginDetails.get('isVendor') : null;

    if (isVendorLogin === '1') {
      return true;
    } else {
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }

}
